module.exports = __webpack_public_path__ + "img/setting.a9fc5179.svg";